import { Label } from 'office-ui-fabric-react';
import { TagPicker } from 'office-ui-fabric-react/lib/Pickers';
import React, { Component } from 'react';
import Scriba from 'react-scriba';
import { Immocom } from '../../specifique/immocom';

export class PickerCPVille extends Component {

    static defaultProps = {
        cp: undefined, // valeur sélectionnée
        disabled: false, // Saisie désactivée
        onBlur: undefined, // Utilisé dans le form dédoublonnement de contact et contact
        onChange: undefined, // évenement
        required: false, // défini si le contrôle est obligatoire
        villeAdministrative: undefined,
    };

    _creationContent = () => {

        const { disabled, required } = this.props;

        return <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12 ms-lg6" name="divPickerCP">
                <Label required={required}>CP</Label>
                <TagPicker
                    disabled={disabled}
                    itemLimit={1}
                    onBlur={e => this._onBlur(e, 'cp')}
                    onChange={this._onChange}
                    onResolveSuggestions={this._onResolveSuggestions}
                    selectedItems={this.state.selectedItemsCP}
                    pickerSuggestionsProps={{
                        suggestionsHeaderText: 'CP - Ville',
                        noResultsFoundText: 'Aucune correspondance'
                    }}
                />
            </div>

            <div className="ms-Grid-col ms-sm12 ms-lg6" name="divPickerVille">
                <Label required={required}>Ville</Label>
                <TagPicker
                    disabled={disabled}
                    itemLimit={1}
                    onBlur={e => this._onBlur(e, 'ville')}
                    onChange={this._onChange}
                    onResolveSuggestions={this._onResolveSuggestions}
                    selectedItems={this.state.selectedItemsVille}
                    pickerSuggestionsProps={{
                        suggestionsHeaderText: 'CP - Ville',
                        noResultsFoundText: 'Aucune correspondance'
                    }}
                />
            </div>
        </div>;
    }

    constructor(props) {
        super(props);

        this.state = {
            idVilleAdministrative: 0,
            villeAdministrative: null,
            cp: null,
            selectedItemsCP: null,
            selectedItemsVille: null
        };
    }

    _chargementDonnees = () => {
        if (this.props.cp !== undefined && this.props.cp != null && this.props.cp !== "") {
            let objetRecherche = {
                "cp": this.props.cp,
                "ville": this.props.villeAdministrative
            };

            var paramPost = Scriba.fetch().createParameterPost(objetRecherche);

            return fetch('api/Get/GetCPVille', paramPost)
                .then(response => response.json())
                .then(responseFetch => {
                    let retourVerif = Scriba.fetch().traitementRetour(responseFetch, this, 100);

                    if (retourVerif.hideMessageBarWarning && retourVerif.hideMessageBarError) {
                        let listCPVille = responseFetch.reponseAPIobjet;
                        let tabCP = [];
                        let tabVille = [];

                        if (listCPVille.length > 0) {
                            listCPVille.map(ville => {
                                tabCP.push({
                                    key: ville.idVilleAdministrative,
                                    name: ville.cpAdministratif,
                                    cp: ville.cpAdministratif,
                                    ville: ville.villeAdministrative,
                                    idDepartementAdministratif: ville.idDepartementAdministratif,
                                    idRegionAdministrative: ville.idRegionAdministrative
                                });
                                tabVille.push({
                                    key: ville.idVilleAdministrative,
                                    name: ville.villeAdministrative,
                                    cp: ville.cpAdministratif,
                                    ville: ville.villeAdministrative,
                                    idDepartementAdministratif: ville.idDepartementAdministratif,
                                    idRegionAdministrative: ville.idRegionAdministrative
                                });
                            });
                        }
                        else { //Saisie manuelle --> on repositionne la valeur dans le champs
                            if (this.props.cp !== undefined && this.props.cp !== "") {
                                tabCP.push({
                                    key: null,
                                    name: this.props.cp
                                });
                            }
                            if (this.props.villeAdministrative !== undefined && this.props.villeAdministrative !== "") {
                                tabVille.push({
                                    key: null,
                                    name: this.props.villeAdministrative
                                });
                            }
                        }

                        this.setState({
                            cp: this.props.cp,
                            villeAdministrative: this.props.villeAdministrative,
                            selectedItemsCP: (tabCP.length === 1 ? tabCP : []),
                            selectedItemsVille: (tabVille.length === 1 ? tabVille : [])
                        });
                    }
                    else {
                        let stateTemp = {};
                        stateTemp.villeAdministrative = null;
                        stateTemp.cp = null;
                        stateTemp.selectedItemsCP = null;
                        stateTemp.selectedItemsVille = null;

                        Immocom.onTraitementErreurAvecState(this, stateTemp, retourVerif, responseFetch);
                    }
                });
        }
        else if (this.props.cp === undefined && this.state.cp !== null) {
            this.setState({
                cp: null,
                villeAdministrative: null,
                selectedItemsCP: [],
                selectedItemsVille: []
            });
        }
    }

    _onResolveSuggestions = (filterText, tagList) => {
        let objetRecherche = {
            "chaineDeRecherche": filterText
        };

        var paramPost = Scriba.fetch().createParameterPost(objetRecherche);

        return fetch('api/Get/GetCPVilleRecherche', paramPost)
            .then(response => response.json())
            .then(responseFetch => {
                let codeRetour = responseFetch.codeRetour;
                let tabCPVille = [];

                if (codeRetour === 0) {
                    let listCPVille = responseFetch.reponseAPIobjet;

                    listCPVille.map(ville => {
                        tabCPVille.push({
                            key: ville.idVilleAdministrative,
                            name: ville.cpAdministratif + ' - ' + ville.villeAdministrative,
                            cp: ville.cpAdministratif,
                            ville: ville.villeAdministrative,
                            idDepartementAdministratif: ville.idDepartementAdministratif,
                            idRegionAdministrative: ville.idRegionAdministrative
                        });
                    });
                }

                return tabCPVille;
            });
    };

    _onChange = (items) => {
        let idVilleAdministrative = null;
        let idDepartementAdministratif = null;
        let idRegionAdministrative = null;
        let codePostal = null;
        let ville = null;

        if (items[0]) {
            idVilleAdministrative = items[0].key;
            idDepartementAdministratif = items[0].idDepartementAdministratif;
            idRegionAdministrative = items[0].idRegionAdministrative;
            codePostal = items[0].cp;
            ville = items[0].ville;
        }

        //Permet de dissocier le CP et la ville dans chaque picker
        //--------------------------------
        let itemsCP = [];
        let itemsVille = [];

        if (items[0]) {

            let itemCP = { ...items[0] }; //Permet de cloner le tableau
            itemCP.name = itemCP.cp; //Modifie l'affichage du champ
            itemsCP.push(itemCP);

            let itemVille = { ...items[0] };
            itemVille.name = itemVille.ville;
            itemsVille.push(itemVille);
        }
        //--------------------------------

        this.setState({
            idVilleAdministrative: idVilleAdministrative,
            cp: codePostal,
            selectedItemsCP: itemsCP,
            selectedItemsVille: itemsVille
        });

        this.props.onChange(idVilleAdministrative, idDepartementAdministratif, idRegionAdministrative, codePostal, ville);
    };

    _onBlur = (value, source) => {
        if (this.props.onBlur !== undefined) {
            if (value !== undefined && (this.state.idVilleAdministrative === undefined || this.state.idVilleAdministrative === null || this.state.idVilleAdministrative === 0)) {
                let Valeur = value.target.value;
                let villeAdminstrativeTrav = ((this.props.villeAdministrative !== undefined && this.props.villeAdministrative !== null) ? this.props.villeAdministrative : "");
                let cpTrav = ((this.props.cp !== undefined && this.props.cp !== null) ? this.props.cp : "");

                if (source === 'cp') {
                    this.props.onBlur(Valeur, villeAdminstrativeTrav);
                }
                else if (source === 'ville') {
                    this.props.onBlur(cpTrav, Valeur);
                }
            }
        }
    }

    componentDidMount = () => {
        this._chargementDonnees();
    }

    componentDidUpdate = () => {
        if (this.props.cp !== this.state.cp) {
            this._chargementDonnees();
        }
    }

    render = () => {
        return this._creationContent();
    }
}